export interface Standard {
  code: string;
  slug: string;
  name: string;
  version: string;
  file: string;
  schemaId: string;
  implemented: boolean;
  messageCount: number;
  categoryCount: number;
  libraryStatus: string;
  status: string;
  issues?: string[];
}
export interface Catalog { standards: Standard[] }
export interface LibraryMessage {
  standard: string;
  ref: number;
  refHex: string;
  title: string;
  category: string;
  categoryName: string;
  severity: number;
  flags?: string;
  categoryKind: 'event' | 'library';
}
export interface DocPage { slug: string; title: string; requiresAccount?: boolean; filename?: string }

export async function fetchContent<T>(file: string, signal?: AbortSignal): Promise<T> {
  const response = await fetch(`/docs-content/${file}`, signal ? { signal } : {});
  if (!response.ok || !response.headers.get('content-type')?.includes('application/json')) {
    throw new Error('The documentation could not be loaded. Please try again.');
  }
  return response.json() as Promise<T>;
}
